export const actions = {
  PRODUCTO_GENERICO_BOCETO_LOAD_REQUESTED: 'PRODUCTO_GENERICO_BOCETO_LOAD_REQUESTED',
  PRODUCTO_GENERICO_BOCETO_LOAD_SUCCEEDED: 'PRODUCTO_GENERICO_BOCETO_LOAD_SUCCEEDED',
  PRODUCTO_GENERICO_BOCETO_LOAD_FAILED: 'PRODUCTO_GENERICO_BOCETO_LOAD_FAILED',

  PRODUCTO_GENERICO_BOCETO_INSERT_REQUESTED: 'PRODUCTO_GENERICO_BOCETO_INSERT_REQUESTED',
  PRODUCTO_GENERICO_BOCETO_INSERT_SUCCEEDED: 'PRODUCTO_GENERICO_BOCETO_INSERT_SUCCEEDED',
  PRODUCTO_GENERICO_BOCETO_INSERT_FAILED: 'PRODUCTO_GENERICO_BOCETO_INSERT_FAILED',

  PRODUCTO_GENERICO_BOCETO_UPDATE_REQUESTED: 'PRODUCTO_GENERICO_BOCETO_UPDATE_REQUESTED',
  PRODUCTO_GENERICO_BOCETO_UPDATE_SUCCEEDED: 'PRODUCTO_GENERICO_BOCETO_UPDATE_SUCCEEDED',
  PRODUCTO_GENERICO_BOCETO_UPDATE_FAILED: 'PRODUCTO_GENERICO_BOCETO_UPDATE_FAILED',

  PRODUCTO_GENERICO_BOCETO_POSICION_UPDATE_REQUESTED:
    'PRODUCTO_GENERICO_BOCETO_POSICION_UPDATE_REQUESTED',
  PRODUCTO_GENERICO_BOCETO_POSICION_UPDATE_SUCCEEDED:
    'PRODUCTO_GENERICO_BOCETO_POSICION_UPDATE_SUCCEEDED',
  PRODUCTO_GENERICO_BOCETO_POSICION_UPDATE_FAILED:
    'PRODUCTO_GENERICO_BOCETO_POSICION_UPDATE_FAILED',

  PRODUCTO_GENERICO_BOCETO_DELETE_REQUESTED: 'PRODUCTO_GENERICO_BOCETO_DELETE_REQUESTED',
  PRODUCTO_GENERICO_BOCETO_DELETE_SUCCEEDED: 'PRODUCTO_GENERICO_BOCETO_DELETE_SUCCEEDED',
  PRODUCTO_GENERICO_BOCETO_DELETE_FAILED: 'PRODUCTO_GENERICO_BOCETO_DELETE_FAILED',
}

export const getProductosGenericosBocetosAction = (dispatch, filter) => {
  dispatch({
    type: actions.PRODUCTO_GENERICO_BOCETO_LOAD_REQUESTED,
    payload: filter,
  })
}

export const setProductosGenericosBocetosAction = (dispatch, payload) => {
  dispatch({
    type: actions.PRODUCTO_GENERICO_BOCETO_INSERT_REQUESTED,
    payload,
  })
}

export const updateProductosGenericosBocetosAction = (dispatch, payload) => {
  dispatch({
    type: actions.PRODUCTO_GENERICO_BOCETO_UPDATE_REQUESTED,
    payload,
  })
}

export const updateProductosGenericosBocetosPosicionAction = (dispatch, payload) => {
  dispatch({
    type: actions.PRODUCTO_GENERICO_BOCETO_POSICION_UPDATE_REQUESTED,
    payload,
  })
}

export const deleteProductosGenericosBocetosAction = (dispatch, id) => {
  dispatch({
    type: actions.PRODUCTO_GENERICO_BOCETO_DELETE_REQUESTED,
    id,
  })
}
